import MollieConnectAssistant from "./MollieConnectAssistant";

export default MollieConnectAssistant;